module.exports = __webpack_public_path__ + "img/menu-yonghu.b2b85f31.svg";